export default __webpack_public_path__ + "static/6641-b3c92be56280df08c31b93351ad10bd8.jpg";